module.exports = __webpack_public_path__ + "c0b6d003456477fa6c9db63c84f45336.svg";